import { AccountArea } from './components/AccountArea';
import { Brand } from './components/Brand';
import { NotificationArea } from './components/NotificationArea';
import { OrganizationBadge } from './components/OrganizationBadge';

type CorporateHeaderProps = {
  activeOrganization: string;
};

export const CorporateHeader = ({
  activeOrganization,
}: CorporateHeaderProps) => (
  <header
    className="arx-corporate-header"
    data-aranox-component="corporate-header"
    aria-label="Cabeçalho corporativo ARANOX"
  >
    <Brand />
    <OrganizationBadge organization={activeOrganization} />

    <div className="arx-corporate-header__actions">
      <NotificationArea />
      <AccountArea />
    </div>
  </header>
);
